export default {
      id: "icon-call-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-call",
      toString: function () {
        return this.url;
      }
    }